module.exports = __webpack_public_path__ + "static/img/HealthCertServicesImg.ccae0d1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HealthCertServicesImg.jpeg
// module id = Ka45
// module chunks = 1